<template>
<div>
    <carousel :perPage="1">
        <slide class="p-1">
            <b-card>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <div class="callout callout-success">
                            <small class="text-muted">Saldo disponível</small>
                            <h4 class="h4">{{ available }}</h4>
                        </div>
                    </div>
                </div>
            </b-card>
        </slide>    
        <slide class="p-1">
            <b-card>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <div class="callout callout-warning">
                            <small class="text-muted">A Receber</small>
                            <h4 class="h4">{{ inProcess }}</h4>
                        </div>
                    </div>    
                </div>
            </b-card>
        </slide>
         <slide class="p-1">
            <b-card>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <div class="callout callout-danger">
                            <small class="text-muted">Bloqueado</small>
                            <h4 class="h4">{{ blocked }}</h4>
                        </div>
                    </div>    
                </div>
            </b-card>
        </slide>    
    </carousel>
</div>
</template>
<script>
import transactionService from "../../services/Transactions/transactionService";
import eventbus from "../../eventBus";
import { Carousel, Slide } from 'vue-carousel';
export default {
    name:'balance-summary',
    components: {
        Carousel,
        Slide
    },
    props: {
        customerId: {
            type: String,
            default: ''
        },
        customerType: {
            type: String,
            default: ''
        },
    },
    data: function() {
        return {
            balance: this.getEmptyBalanceSummary(),
        }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        const self = this;
        eventbus.$on(`balance-summary:refresh`, function() {            
            self.fetchData();
        }); 
    },
    computed: {
        available() {
            return this.balance.available.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        inProcess() {
            return this.balance.inProcess.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        blocked() {
            return this.balance.blocked.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        total() {
            return this.balance.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
    },
    methods: {
        getEmptyBalanceSummary() {
            return { available: 0, inProcess: 0, blocked: 0, total: 0 }
        },
        fetchData() {
            const self = this
            let customerId = '';
            let customerType = '';
            customerId = this.customerId == '' ? this.$store.getters.currentUser.id : this.customerId;
            customerType = this.customerType == '' ? 'SELLER' : this.customerType

            transactionService.balance({customerId: customerId, customerType: customerType})
                .then(
                (response) => {
                        if (response.status == 204) {
                            self.balance.available = 0;
                            self.balance.inProcess = 0;
                            self.balance.total = 0;
                            self.balance.blocked = 0;       
                        }
                        else {
                            self.balance.available = response.data.available;
                            self.balance.inProcess = response.data.inProcess;
                            self.balance.total = response.data.total;              
                            self.balance.blocked = response.data.onHold
                        }
                        eventbus.$emit('balance-summary:fetch', self.balance);
                    },
                    () => {}
                );
        },
    }
}
</script>